import { Box, Chip, Grid, Tab, Tabs } from "@mui/material";
import EquitySection from "./EquitySection";
import { PaginationState } from "types/common";
import { IStock } from "types/stock";
import { IFno } from "types/fno";
import FnoSection from "./FnoSection";
import FileUploadCard from "./FileUploadCard";
type Props = {
	equities: IStock[];
	fno: IFno[];
	page: PaginationState;
	setPage: (val: PaginationState) => void;
	loading: boolean;
	totalNumberOfEquities: number;
	totalNumberOfFno: number;
	tabValue: number;
	setTabValue: React.Dispatch<React.SetStateAction<number>>;
	fetchFno: () => void;
	fetchEquities: () => void;
};
const InstrumentTabs: React.FC<Props> = ({
	page,
	equities,
	fno,
	totalNumberOfEquities,
	totalNumberOfFno,
	loading,
	tabValue,
	setTabValue,
	fetchFno,
	fetchEquities,
}) => {
	const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
		if (tabValue !== newValue) {
			setTabValue(newValue);
		}
	};

	const renderTabContent = () => {
		switch (tabValue) {
			case 0:
				return (
					<Box mt={4}>
						<FileUploadCard
							tabValue={tabValue}
							fetchFno={fetchFno}
							fetchEquities={fetchEquities}
						/>
						<Grid sx={{ mt: 3 }}>
							<EquitySection
								loading={loading}
								equities={equities}
								page={page}
								totalNumberOfEquities={totalNumberOfEquities}
							/>
						</Grid>
					</Box>
				);
			case 1:
				return (
					<Box mt={4}>
						<FileUploadCard
							tabValue={tabValue}
							fetchFno={fetchFno}
							fetchEquities={fetchEquities}
						/>
						<Grid sx={{ mt: 3 }}>
							<FnoSection
								loading={loading}
								fno={fno}
								page={page}
								totalNumberOfFno={totalNumberOfFno}
							/>
						</Grid>
					</Box>
				);
			default:
				return null;
		}
	};

	return (
		<>
			<Box sx={{ mt: 10 }}>
				<Tabs
					value={tabValue}
					onChange={handleTabChange}
					aria-label="order-tabs">
					<Tab
						label="Equity"
						icon={
							<Chip
								label={totalNumberOfEquities}
								color="primary"
								variant="outlined"
								size="small"
							/>
						}
						value={0}
						iconPosition="end"
						sx={{ minWidth: 160 }}
					/>
					<Tab
						label="FNO"
						icon={
							<Chip
								label={totalNumberOfFno}
								color="primary"
								variant="outlined"
								size="small"
							/>
						}
						value={1}
						iconPosition="end"
						sx={{ minWidth: 160 }}
					/>
				</Tabs>
			</Box>
			<Box sx={{ width: "100%" }}>{renderTabContent()}</Box>
		</>
	);
};

export default InstrumentTabs;
